<template>
  <section v-if="items.length" v-schedule-view class="excursion-schedule">
    <h2 class="excursion-schedule__title">{{ t('schedule.title') }}</h2>

    <ul class="excursion-schedule__list">
      <li v-for="item in items" :key="item.id" class="excursion-schedule__item">
        <div class="excursion-schedule__meta">
          <span v-if="item.startsAt" class="excursion-schedule__datetime">{{ formatStartsAt(item.startsAt) }}</span>
          <span v-if="item.priceText" class="excursion-schedule__price">{{ item.priceText }}</span>
        </div>
        <AppLink
          v-schedule-experience-click="{ experience_id: item.id }"
          class="excursion-schedule__link"
          :to="item.url"
        >
          {{ item.title }}
        </AppLink>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from '@experience/i18n';

import { useAnalytics } from '@/shared/lib/analytics';
import { formatShortDateTime } from '@/shared/utils/time';

import ru from '../i18n/ru.json';

import type { AttractionScheduleItem } from '../models/attractionCard';

defineProps<{
  items: AttractionScheduleItem[];
}>();

const { useViewTracker, useImmediateClickTracker } = useAnalytics();
const vScheduleView = useViewTracker('sight:schedule.view');
// ссылка уводит со страницы, батч не успевает уйти — шлём сразу, с keepalive
const vScheduleExperienceClick = useImmediateClickTracker('sight:schedule:experience.click');

const { t } = useI18n<{ message: typeof ru }, 'ru'>({
  inheritLocale: true,
  messages: { ru },
});

const formatStartsAt = (startsAt: Date | string) => formatShortDateTime(startsAt);
</script>

<style scoped lang="scss">
.excursion-schedule__title {
  margin: 0;

  @include typography.base-800-800-semi;

  @include tablet {
    @include typography.base-700-500-semi;
  }
}

.excursion-schedule__list {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 24px 32px;
  padding: 0;
  margin: 24px 0 0;
  list-style: none;

  @include tablet {
    margin: 16px 0 0;
  }

  @include mobile {
    grid-template-columns: minmax(0, 1fr);
  }
}

.excursion-schedule__item {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: start;

  @include mobile {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
}

.excursion-schedule__meta {
  display: flex;
  flex-direction: column;
}

.excursion-schedule__datetime,
.excursion-schedule__price {
  color: var(--alias-color-text-default);
  white-space: nowrap;

  @include typography.base-500-400-medium;
}

.excursion-schedule__link {
  color: var(--alias-color-link-darked);
  text-decoration: underline;
  text-decoration-style: solid;

  @include typography.base-500-400-regular;

  @include mobile {
    align-self: stretch;

    @include typography.base-400-400-regular;
  }

  &:hover {
    color: var(--alias-color-link-default);
  }
}
</style>
